type EnvConfig = {
  api: {
    clmApiUrl: string;
    clmAccountApiUrl: string;
    clmUserApiUrl: string;
    clmUserCoreApiUrl: string;
  };
  environment: string;
  mode: 'local' | 'staging' | 'pre-production' | 'production';
};

const DEFAULT_STAGING_CONFIG = {
  api: {
    clmApiUrl: 'https://clm-api-us.adc-clm.io/v1/',
    clmAccountApiUrl: 'https://api-account.us.stage.adc-clm.io/v1/',
    clmUserApiUrl: 'https://api-user.us.stage.adc-clm.io/v1/',
    clmUserCoreApiUrl: 'https://api-user-core.us.stage.adc-clm.io/v1/',
  },
  environment: 'local_default',
  mode: 'staging',
} as const satisfies EnvConfig;

export const _config = DEFAULT_STAGING_CONFIG;

export const getEnvConfig = async () => {
  const response = await fetch('/config.json', {
    method: 'GET',
    headers: {
      'Content-type': 'application/json',
    },
  });

  if (response.ok) {
    const data = (await response.json()) as EnvConfig;

    Object.assign(_config, data);

    return data;
  }

  throw new Error('Failed to load environment configuration');
};
